import { CDN_URL } from '../configs/configs';
import network from './network';

type FileType = 'photo' | 'files' | 'file';

interface Files {
  url: string;
  org_name: string;
}

interface ResponseUploadFiles {
  code: number;
  message: string;
  data: Files[];
}

interface ParamsUploadFiles {
  fileType: FileType;
  files: FileList;
}

interface RequestFilePath {
  file_type: string;
  mime_type: string;
  org_name: string;
  url: string;
}

async function uploadFiles(params: ParamsUploadFiles): Promise<ResponseUploadFiles> {
  const formData = new FormData();

  formData.append('file_type', params.fileType);
  Array.from(params.files).forEach((file: File) => {
    formData.append('file[]', file);
  });

  const data = await network().storage().uploadFiles(formData);

  return data;
}

function toRequestFilePaths(fileType: FileType, url: Files[]): RequestFilePath[] {
  return url.map((item: Files): RequestFilePath => {
    const { url: _url, org_name } = item;
    return {
      file_type: fileType,
      mime_type: getMimeType(_url),
      org_name: org_name ?? _url.split('/').pop() ?? '',
      url: `${CDN_URL}/${_url}`,
    };
  });
}

function getMimeType(filename: string) {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  switch (ext) {
    // image
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    case 'webp':
      return 'image/webp';
    case 'svg':
      return 'image/svg+xml';
    // file document
    case 'hwpx':
      return 'application/vnd.hancom.hwpx';
    case 'hwp':
      return 'application/vnd.hancom.hwp';
    case 'doc':
    case 'docx':
      return 'application/msword';
    case 'ppt':
    case 'pptx':
      return 'application/vnd.ms-powerpoint';
    case 'xls':
    case 'xlsx':
      return 'application/vnd.ms-excel';
    default:
      return 'application/octet-stream'; // 알 수 없는 경우
  }
}

export { uploadFiles, type ParamsUploadFiles, type ResponseUploadFiles, toRequestFilePaths };
